export default __webpack_public_path__ + "static/media/roles_2.fbb0dabc.png";